import React from 'react';

import { useQuery } from '@apollo/client';
import { Alert, Box, Divider, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material';
import dayjs from 'dayjs';

import signatureGQLSchemas from '../../../../../services/signatures/gqlSchema';

const CandidateCardContractSigned = ({ dataSignaturesByContact, signerInfos, contactInfo }) => {
  const { data } = useQuery(signatureGQLSchemas.Query.recoveryCandidateDocument, {
    variables: {
      signUuid: dataSignaturesByContact.signUuid,
      contactInfoId: contactInfo.id,
      category: 'CONTRACT_CANDIDATE',
    },
  });

  return (
    <>
      <Alert severity='success'>
        Votre contrat a été signé à la date du <strong>{new Date(signerInfos.actionDate).toLocaleString()}</strong>
      </Alert>
      <List>
        {data?.recoveryCandidateDocument.map(doc => {
          return (
            <Box key={doc.id}>
              <ListItem sx={{ alignItems: 'flex-start' }} key={doc.id}>
                <ListItemButton component='a' href={doc.public_url} target='_blank' rel='noopener noreferrer'>
                  <ListItemText
                    primary={doc.filename}
                    secondary={
                      <Typography component='span' sx={{ display: 'block', fontSize: '13px', marginTop: '5px' }}>
                        Publié le {dayjs(doc.createdAt).format('DD/MM/YYYY à HH:mm:ss')}
                      </Typography>
                    }
                  ></ListItemText>
                </ListItemButton>
              </ListItem>
              <Divider />
            </Box>
          );
        })}
      </List>
    </>
  );
};

export default React.memo(CandidateCardContractSigned);
